/**
* Benefits Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Benefits Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'benefits-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.benefits-scroller__card' ).each( function( key, card ) {
        const height = window.innerHeight - $( card ).height();
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            end: '+=' + height,
            scrub: 1,
            // markers: true,
          },
        } );
        tl.to( card, {y: '0%', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'benefits-scroller', COMPONENT );
} )( app );
